import { Dialog, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { Fragment } from "react";
import { useAppContext } from "../../context/AppContext";

export default function SidePanel({
  open,
  closeSideBar,
  children,
  minWidth = true,
  background,
}) {
  const appState = useAppContext();
  return (
    <Transition.Root
      show={open}
      as={Fragment}
      className={`${appState.state.darkMode ? "dark" : " "} relative z-30`}
    >
      <Dialog as="div" className="relative z-20" onClose={closeSideBar}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 backdrop-blur-md bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto relative w-screen md:max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div
                      className={`absolute z-10 top-0 left-0 ml-4 md:-ml-4 flex mt-4 p-1 rounded-full ${background} `}
                    >
                      <button
                        type="button"
                        className="rounded-md "
                        onClick={closeSideBar}
                      >
                        <Icon
                          icon="carbon:close"
                          color={appState.state.darkMode ? "#fff" : "#000"}
                          className="h-6 w-6"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  <div
                    className={`flex h-full flex-col overflow-y-scroll ${background} shadow-xl 
                  w-full`}
                  >
                    {children}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
